<template>
  <cadastro-base
    :salvar="salvar"
    :cancelar="cancelar"
    :mostrar-rodape="abaAtiva === 0"
  >
    <template slot="conteudo">
      <b-tabs
          content-class="mt-2"
          @input="abaAtiva = $event"
        >

        <!-- ── Aba Principal ─────────────────────────────────────────────── -->
        <b-tab
          title="Configuração"
          active
          no-body
        >
      <!-- ── SMTP Principal ─────────────────────────────────────────────── -->
      <b-row>
        <b-col cols="6">
          <b-form-group
            label="Servidor de saída de e-mails"
            label-for="servidorInput"
          >
            <validation-provider
              #default="{ errors }"
              :rules="{required: true}"
              name="Servidor"
              auto-focus
            >
              <b-form-input
                id="servidorInput"
                v-model="form.servidor"
                placeholder="Informe o nome do servidor de email"
                type="text"
                :state="errors.length > 0 ? false : null "
                @input="LimparMensagemEmailSaidaErro"
              />
              <small class="text-danger">{{ errors[0] || emailSaidaMensagemErro }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group
            label="Porta"
            label-for="portaInput"
          >
            <validation-provider
              #default="{ errors }"
              :rules="{required: true}"
              name="Porta"
            >
              <b-form-input
                id="portaInput"
                v-model="form.porta"
                type="number"
                :state="errors.length > 0 ? false : null "
                @input="ValidarCriptografia"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group
            label="Criptografia"
            label-for="criptInput"
          >
            <validation-provider
              #default="{ errors }"
              :rules="{required: true}"
              name="Servidor de email"
              auto-focus
            >
              <b-select
                id="criptInput"
                v-model="form.criptografia"
                :state="errors.length > 0 ? false : null "
                :options="criptografiaOptions"
                @input="ValidarCriptografia(), LimparMensagemCriptografiaErro()"
              />
              <small class="text-danger">{{ errors[0] || criptografiaMensagemErro }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <b-form-group
            label="E-mail remetente padrão"
            label-for="emailInput"
          >
            <validation-provider
              #default="{ errors }"
              :rules="{required: true}"
              name="E-mail"
            >
              <b-form-input
                id="emailInput"
                v-model="form.emailRemetente"
                placeholder="Informe o e-mail do remetente"
                type="email"
                :state="errors.length > 0 ? false : null "
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group
            label="Login SMTP"
            label-for="loginInput"
          >
            <b-form-input
              id="loginInput"
              v-model="form.login"
              placeholder="Se diferente do e-mail"
              type="text"
            />
            <small class="text-muted">Opcional</small>
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group
            label="Senha"
            label-for="senhaInput"
          >
            <validation-provider
              #default="{ errors }"
              :rules="{required: true}"
              name="Senha"
            >
              <senha-input
                :id="'senhaInput'"
                v-model="form.senha"
                :state="errors.length > 0 ? false : null "
                auto-complete-senha="new-password"
                type="password"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <b-form-group
            label="Descrição remetente"
            label-for="descRemetenteInput"
          >
            <b-form-input
              id="descRemetenteInput"
              v-model="form.descRemetente"
              type="text"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <b-form-group
            label-for="assinaturaInput"
            label="Assinatura do e-mail"
          >
            <upload-e-visualizacao
              id="assinaturaInput"
              ref="upload"
              :value="form.assinatura"
              :titulo="'assinatura'"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <loading
        class="loading"
        :show-cancel-button="false"
        :is-loading="isLoading"
        :titulo-carregamento="'Aguarde!'"
        :descricao="'Verificando SMTP'"
      />
        </b-tab>

        <!-- ── Aba SMTPs Adicionais ──────────────────────────────────────── -->
        <b-tab
          title="SMTPs Adicionais"
          no-body
        >
      <b-row class="align-items-center mb-2 mt-2">
        <b-col>
          <small class="text-muted">Adicione dados do SMTP individualizado para cada usuário ou grupos de usuários</small>
        </b-col>
        <b-col cols="auto">
          <b-dropdown
            text="+ Novo"
            variant="outline-primary"
            size="sm"
            right
          >
            <b-dropdown-item @click="abrirNovoGrupo">
              Grupo
            </b-dropdown-item>
            <b-dropdown-item @click="abrirNovoUsuario">
              Usuário
            </b-dropdown-item>
          </b-dropdown>
        </b-col>
      </b-row>

      <!-- Seção Grupos -->
      <div
        v-if="grupos.length > 0"
        class="smtp-secao mb-2"
      >
        <div
          class="smtp-secao-header"
          @click="mostrarGrupos = !mostrarGrupos"
        >
          <span class="font-weight-bold">SMTP por Grupo de Usuários</span>
          <b-badge
            v-if="grupos.length > 0"
            variant="primary"
            class="ml-1"
          >
            {{ grupos.length }}
          </b-badge>
          <div style="float:right">
            <feather-icon
              :icon="mostrarGrupos ? 'ChevronUpIcon' : 'ChevronDownIcon'"
              style="margin-right:0.25rem"
            />
          </div>
        </div>
        <br>
        <b-col cols="12">
          <hr
            class="mx-0 mt-0 mb-2"
            style="border-top: 0.1rem solid #a3a4a66b !important;"
          >
        </b-col>
        <b-collapse v-model="mostrarGrupos">
          <div
            v-for="(grupo, gi) in grupos"
            :key="'grupo-' + (grupo.id || 'novo-' + gi)"
            class="smtp-adicional-card mb-2"
          >
            <div
              class="smtp-adicional-header d-flex align-items-center justify-content-between"
              @click="toggleGrupo(gi)"
            >
              <span class="font-weight-bold">
                {{ grupo.nome || 'Novo grupo' }}
                <b-badge
                  v-if="grupo.usuarioIds && grupo.usuarioIds.length"
                  variant="secondary"
                  class="ml-1"
                >
                  {{ grupo.usuarioIds.length }} usuário(s)
                </b-badge>
              </span>
              <div class="d-flex align-items-center">
                <feather-icon
                  v-if="grupo.id"
                  icon="Trash2Icon"
                  class="text-danger cursor-pointer mr-2"
                  size="16"
                  @click.stop="removerGrupo(gi)"
                />
                <feather-icon
                  :icon="grupo.aberto ? 'ChevronUpIcon' : 'ChevronDownIcon'"
                  size="16"
                />
              </div>
            </div>
            <b-collapse :visible="grupo.aberto">
              <div class="smtp-adicional-body">
                <b-row class="align-items-end">
                  <b-col cols="5">
                    <b-form-group
                      label="Nome do grupo"
                      class="mb-1"
                    >
                      <b-form-input
                        v-model="grupo.nome"
                        placeholder="Nome do grupo"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group
                      label="Usuários"
                      class="mb-1"
                    >
                      <div class="usuario-tag-container form-control">
                        <span
                          v-for="uid in grupo.usuarioIds"
                          :key="uid"
                          class="usuario-tag"
                        >
                          {{ nomeUsuario(uid) }}
                          <span
                            class="usuario-tag-x"
                            @click="removerUsuarioDoGrupo(grupo, uid)"
                          >&times;</span>
                        </span>
                        <b-form-select
                          v-model="grupo.selecionando"
                          class="usuario-tag-select"
                          :options="opcoesMembrosGrupo(grupo)"
                          @change="adicionarUsuarioAoGrupo(grupo, $event)"
                        >
                          <template #first>
                            <b-form-select-option
                              value=""
                              disabled
                            >
                              Selecionar usuário...
                            </b-form-select-option>
                          </template>
                        </b-form-select>
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="3">
                    <b-form-group label="Servidor de saída de e-mail">
                      <b-form-input
                        v-model="grupo.servidor"
                        :placeholder="form.servidor || 'Informe o servidor'"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="2">
                    <b-form-group label="Porta">
                      <b-form-input
                        v-model="grupo.porta"
                        type="number"
                        :placeholder="String(form.porta || '')"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="2">
                    <b-form-group label="Criptografia">
                      <b-select
                        v-model="grupo.criptografia"
                        :options="getCriptografiaOptions(grupo.porta)"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="3">
                    <b-form-group label="E-mail remetente padrão">
                      <b-form-input
                        v-model="grupo.emailRemetente"
                        :placeholder="form.emailRemetente || 'sugerir e-mail do cadastro'"
                        type="email"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="2">
                    <b-form-group label="Login SMTP">
                      <b-form-input
                        v-model="grupo.login"
                        placeholder="Se diferente do e-mail"
                      />
                      <small class="text-muted">Opcional</small>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="2">
                    <b-form-group label="Senha">
                      <senha-input
                        :id="'senha-grupo-' + gi"
                        v-model="grupo.senha"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="4">
                    <b-form-group label="Descrição remetente">
                      <b-form-input v-model="grupo.descRemetente" />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="4">
                    <b-form-group label="Assinatura do e-mail">
                      <upload-e-visualizacao
                        :id="'assinatura-grupo-' + gi"
                        :ref="'uploadGrupo' + gi"
                        :value="grupo.assinatura"
                        titulo="assinatura"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-button
                      variant="primary"
                      size="sm"
                      :disabled="grupo._salvando"
                      @click="salvarGrupo(grupo, gi)"
                    >
                      {{ grupo._salvando ? 'Verificando SMTP...' : 'Salvar' }}
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </b-collapse>
          </div>
        </b-collapse>
      </div>

      <!-- Seção Usuários Individuais -->
      <div
        v-if="usuariosSmtp.length > 0"
        class="smtp-secao mb-2"
      >
        <div
          class="smtp-secao-header"
          @click="mostrarUsuarios = !mostrarUsuarios"
        >
          <span class="font-weight-bold">SMTP por Usuário Individual</span>
          <b-badge
            v-if="usuariosSmtp.length > 0"
            variant="primary"
            class="ml-1"
          >
            {{ usuariosSmtp.length }}
          </b-badge>
          <div style="float:right">
            <feather-icon
              :icon="mostrarUsuarios ? 'ChevronUpIcon' : 'ChevronDownIcon'"
              style="margin-right:0.25rem"
            />
          </div>
        </div>
        <br>
        <b-col cols="12">
          <hr
            class="mx-0 mt-0 mb-2"
            style="border-top: 0.1rem solid #a3a4a66b !important;"
          >
        </b-col>
        <b-collapse v-model="mostrarUsuarios">
          <div
            v-for="(smtpUsr, ui) in usuariosSmtp"
            :key="'usuario-' + (smtpUsr.id || 'novo-' + ui)"
            class="smtp-adicional-card mb-2"
          >
            <div
              class="smtp-adicional-header d-flex align-items-center justify-content-between"
              @click="toggleUsuarioSmtp(ui)"
            >
              <span class="font-weight-bold">
                {{ nomeCompletoUsuario(smtpUsr) || 'Novo usuário' }}
              </span>
              <div class="d-flex align-items-center">
                <feather-icon
                  v-if="smtpUsr.id"
                  icon="Trash2Icon"
                  class="text-danger cursor-pointer mr-2"
                  size="16"
                  @click.stop="removerUsuarioSmtp(ui)"
                />
                <feather-icon
                  :icon="smtpUsr.aberto ? 'ChevronUpIcon' : 'ChevronDownIcon'"
                  size="16"
                />
              </div>
            </div>
            <b-collapse :visible="smtpUsr.aberto">
              <div class="smtp-adicional-body">
                <b-alert
                  v-if="smtpUsr.estaEmGrupo"
                  show
                  variant="warning"
                  class="mb-2"
                >
                  Configuração inativa — usuário pertence ao grupo <strong>{{ smtpUsr.nomeGrupo }}</strong>.
                </b-alert>
                <b-row>
                  <b-col cols="3">
                    <b-form-group label="Usuário">
                      <b-form-select
                        v-model="smtpUsr.usuarioId"
                        :options="smtpUsr.id > 0 ? [{ value: smtpUsr.usuarioId, text: smtpUsr.nomeUsuario }] : (smtpUsr.usuariosDisponiveis || [])"
                        :disabled="smtpUsr.id > 0"
                      >
                        <template #first>
                          <b-form-select-option
                            :value="null"
                            disabled
                          >
                            Selecionar usuário...
                          </b-form-select-option>
                        </template>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="3">
                    <b-form-group label="Servidor de saída de e-mail">
                      <b-form-input
                        v-model="smtpUsr.servidor"
                        :placeholder="form.servidor || 'Informe o servidor'"
                        :disabled="smtpUsr.estaEmGrupo"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="2">
                    <b-form-group label="Porta">
                      <b-form-input
                        v-model="smtpUsr.porta"
                        type="number"
                        :placeholder="String(form.porta || '')"
                        :disabled="smtpUsr.estaEmGrupo"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="2">
                    <b-form-group label="Criptografia">
                      <b-select
                        v-model="smtpUsr.criptografia"
                        :options="getCriptografiaOptions(smtpUsr.porta)"
                        :disabled="smtpUsr.estaEmGrupo"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="3">
                    <b-form-group label="E-mail remetente padrão">
                      <b-form-input
                        v-model="smtpUsr.emailRemetente"
                        placeholder="sugerir e-mail do cadastro"
                        type="email"
                        :disabled="smtpUsr.estaEmGrupo"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="2">
                    <b-form-group label="Login SMTP">
                      <b-form-input
                        v-model="smtpUsr.login"
                        placeholder="Se diferente do e-mail"
                        :disabled="smtpUsr.estaEmGrupo"
                      />
                      <small class="text-muted">Opcional</small>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="2">
                    <b-form-group label="Senha">
                      <senha-input
                        :id="'senha-usuario-' + ui"
                        v-model="smtpUsr.senha"
                        :disabled="smtpUsr.estaEmGrupo"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="4">
                    <b-form-group label="Descrição remetente">
                      <b-form-input
                        v-model="smtpUsr.descRemetente"
                        :disabled="smtpUsr.estaEmGrupo"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="4">
                    <b-form-group label="Assinatura do e-mail">
                      <upload-e-visualizacao
                        :id="'assinatura-usuario-' + ui"
                        :ref="'uploadUsuario' + ui"
                        :value="smtpUsr.assinatura"
                        titulo="assinatura"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row v-if="!smtpUsr.estaEmGrupo">
                  <b-col>
                    <b-button
                      variant="primary"
                      size="sm"
                      :disabled="smtpUsr._salvando"
                      @click="salvarUsuarioSmtp(smtpUsr, ui)"
                    >
                      {{ smtpUsr._salvando ? 'Verificando SMTP...' : 'Salvar' }}
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </b-collapse>
          </div>
        </b-collapse>
      </div>
        </b-tab>

      </b-tabs>
    </template>
  </cadastro-base>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import mixins from '@pilar/mixins/upload'
import api from './shared/services/api'
import EventBus from '../shared/mixins/event-bus/eventBus'
import apiTermos from '../shared/services/api-termos'

const smtpVazio = (extra = {}) => ({
  id: 0,
  servidor: '',
  porta: '',
  criptografia: 'none',
  emailRemetente: '',
  login: '',
  senha: '',
  descRemetente: '',
  assinatura: null,
  aberto: true,
  _salvando: false,
  ...extra,
})

export default {
  name: 'EmailConfiguracao',
  components: {
    ValidationProvider,
    SenhaInput: () => import('@pilar/components/senha-input/SenhaInput.vue'),
    UploadEVisualizacao: () => import('@pilar/plugins/upload-e-visualizacao/UploadEVisualizacao.vue'),
    CadastroBase: () => import('@pilar/components/cadastro-base/CadastroBase.vue'),
    Loading: () => import('@pilar/components/loading/Loading.vue'),
  },
  mixins: [mixins],
  data() {
    return {
      required,
      form: {},
      criptografiaOptions: [
        { text: 'Nenhum', value: 'none', disabled: false },
        { text: 'SSL', value: 'ssl', disabled: false },
        { text: 'TSL', value: 'tsl', disabled: false },
      ],
      isLoading: false,
      emailSaidaMensagemErro: '',
      criptografiaMensagemErro: '',
      grupos: [],
      usuariosSmtp: [],
      abaAtiva: 0,
      mostrarGrupos: true,
      mostrarUsuarios: true,
    }
  },
  created() {
    this.carregar()
  },
  methods: {
    getDefaultValue() {
      return {
        id: 0,
        servidor: '',
        porta: '',
        criptografia: 'none',
        emailRemetente: '',
        login: '',
        senha: '',
        descRemetente: '',
      }
    },

    carregar() {
      api.get().then(payload => {
        this.form = payload.data || this.getDefaultValue()
      })
      api.getGrupos().then(payload => {
        this.grupos = (payload.data || []).map(g => ({
          ...g,
          usuarioIds: (g.usuarios || []).map(u => u.usuarioId),
          aberto: false,
          _salvando: false,
          selecionando: '',
        }))
      })
      api.getUsuariosSmtp().then(payload => {
        this.usuariosSmtp = (payload.data || []).map(u => ({ ...u, aberto: false, _salvando: false }))
      })
    },

    // ── SMTP Principal ──────────────────────────────────────────────────
    salvar() {
      this.isLoading = true
      return new Promise((resolve, reject) => {
        apiTermos.getPendentes([1])
          .then(r => {
            if (r.data?.length) {
              this.isLoading = false
              EventBus.$emit('termosPendentes', r.data)
              EventBus.$once('termoAceito', () => this.executarSalvamento(resolve, reject))
            } else {
              this.executarSalvamento(resolve, reject)
            }
          })
          .catch(() => this.executarSalvamento(resolve, reject))
      })
    },

    executarSalvamento(resolve, reject) {
      this.isLoading = true
      this.LimparMensagemEmailSaidaErro()
      this.LimparMensagemCriptografiaErro()
      const form = { ...this.form }
      form.assinatura = null
      const formData = this.$refs.upload.getFormDataBody(form)
      api.update(formData)
        .then(payload => {
          this.form.id = payload.data
          resolve('Configuração de e-mail cadastrada com sucesso')
          this.isLoading = false
        })
        .catch(err => {
          if (err.response.data.message === 'Configuração de SMTP inválido: Servidor de saída de e-mails não é valido') {
            this.emailSaidaMensagemErro = 'Preencha o campo corretamente'
          } else if (err.response.data.message === 'Configuração de SMTP inválido: Criptografia inválida') {
            this.criptografiaMensagemErro = 'Preencha o campo corretamente'
          }
          reject(new Error(err.response.data.message))
          this.isLoading = false
        })
    },

    cancelar() {
      this.$router.push({ name: 'dashboard-analitico' })
    },

    // ── Grupos ──────────────────────────────────────────────────────────
    async abrirNovoGrupo() {
      const payload = await api.getUsuariosDisponiveisParaGrupo()
      const disponiveis = (payload.data || []).map(u => ({ value: u.id, text: u.nome })).sort((a, b) => a.text.localeCompare(b.text, 'pt-BR'))
      this.grupos.push({
        ...smtpVazio(),
        nome: '',
        usuarioIds: [],
        aberto: true,
        _salvando: false,
        selecionando: '',
        usuariosDisponiveis: disponiveis,
      })
    },

    async toggleGrupo(index) {
      const aberto = !this.grupos[index].aberto
      this.$set(this.grupos, index, { ...this.grupos[index], aberto })
      if (aberto) {
        const grupoId = this.grupos[index].id || null
        const payload = await api.getUsuariosDisponiveisParaGrupo(grupoId)
        const disponiveis = (payload.data || []).map(u => ({ value: u.id, text: u.nome })).sort((a, b) => a.text.localeCompare(b.text, 'pt-BR'))
        this.$set(this.grupos[index], 'usuariosDisponiveis', disponiveis)
      }
    },

    adicionarUsuarioAoGrupo(grupo, uid) {
      if (uid && !grupo.usuarioIds.includes(Number(uid))) {
        grupo.usuarioIds.push(Number(uid))
      }
      const index = this.grupos.indexOf(grupo)
      if (index !== -1) this.$set(this.grupos[index], 'selecionando', '')
    },

    removerUsuarioDoGrupo(grupo, uid) {
      const index = this.grupos.indexOf(grupo)
      if (index !== -1) {
        this.$set(this.grupos[index], 'usuarioIds', grupo.usuarioIds.filter(id => id !== uid))
      }
    },

    opcoesMembrosGrupo(grupo) {
      const jaNoGrupo = new Set(grupo.usuarioIds)
      return (grupo.usuariosDisponiveis || []).filter(u => !jaNoGrupo.has(u.value))
    },

    nomeCompletoUsuario(smtpUsr) {
      if (smtpUsr.nomeUsuario) return smtpUsr.nomeUsuario
      if (smtpUsr.usuariosDisponiveis) {
        const opt = smtpUsr.usuariosDisponiveis.find(x => x.value === smtpUsr.usuarioId)
        if (opt) return opt.text
      }
      return ''
    },

    nomeUsuario(uid) {
      const gu = this.grupos.flatMap(g => g.usuarios || []).find(x => x.usuarioId === uid)
      if (gu) return gu.primeiroNome || gu.nomeCompleto.split(' ')[0]

      const su = this.usuariosSmtp.find(x => x.usuarioId === uid)
      if (su && su.nomeUsuario) return su.nomeUsuario.split(' ')[0]

      const disp = this.grupos.flatMap(g => g.usuariosDisponiveis || []).find(x => x.value === uid)
      if (disp) return disp.text.split(' ')[0]

      return ''
    },

    async salvarGrupo(grupo, index) {
      this.$set(this.grupos[index], '_salvando', true)
      const refUpload = this.$refs[`uploadGrupo${index}`]
      const file = refUpload ? refUpload[0]?.getFile?.() : null
      const body = {
        id: grupo.id || 0,
        nome: grupo.nome,
        servidor: grupo.servidor,
        porta: Number(grupo.porta),
        criptografia: grupo.criptografia,
        emailRemetente: grupo.emailRemetente,
        login: grupo.login || null,
        senha: grupo.senha,
        descRemetente: grupo.descRemetente || null,
        usuarioIds: grupo.usuarioIds,
      }
      api.salvarGrupo(file, body)
        .then(payload => {
          this.$set(this.grupos, index, {
            ...this.grupos[index],
            ...payload.data,
            usuarioIds: (payload.data.usuarios || []).map(u => u.usuarioId),
            aberto: false,
            _salvando: false,
            selecionando: '',
          })
          api.getUsuariosSmtp().then(r => {
            this.usuariosSmtp = (r.data || []).map(u => ({ ...u, aberto: false, _salvando: false }))
          })
          this.$sucesso('Grupo de SMTP salvo com sucesso')
        })
        .catch(err => {
          this.$set(this.grupos[index], '_salvando', false)
          this.$erro(err?.response?.data?.message || 'Erro ao salvar grupo de SMTP')
        })
    },

    removerGrupo(index) {
      const grupo = this.grupos[index]
      if (!grupo.id) { this.grupos.splice(index, 1); return }
      this.$bvModal.msgBoxConfirm('Deseja remover este grupo de SMTP?', {
        title: 'Confirmar remoção',
        okVariant: 'danger',
        okTitle: 'Remover',
        cancelTitle: 'Cancelar',
      })
        .then(ok => {
          if (!ok) return
          api.removerGrupo(grupo.id)
            .then(() => {
              this.grupos.splice(index, 1)
              api.getUsuariosSmtp().then(r => {
                this.usuariosSmtp = (r.data || []).map(u => ({ ...u, aberto: false, _salvando: false }))
              })
            })
            .catch(() => this.$erro('Erro ao remover grupo'))
        })
    },

    // ── SMTP Individual ─────────────────────────────────────────────────
    async abrirNovoUsuario() {
      const payload = await api.getUsuariosDisponiveisParaIndividual()
      const disponiveis = (payload.data || []).map(u => ({ value: u.id, text: u.nome })).sort((a, b) => a.text.localeCompare(b.text, 'pt-BR'))
      this.usuariosSmtp.push({
        ...smtpVazio(),
        usuarioId: null,
        aberto: true,
        _salvando: false,
        usuariosDisponiveis: disponiveis,
      })
    },

    async toggleUsuarioSmtp(index) {
      const aberto = !this.usuariosSmtp[index].aberto
      this.$set(this.usuariosSmtp, index, { ...this.usuariosSmtp[index], aberto })
      if (aberto && !this.usuariosSmtp[index].id) {
        const smtpId = this.usuariosSmtp[index].id || null
        const payload = await api.getUsuariosDisponiveisParaIndividual(smtpId)
        const disponiveis = (payload.data || []).map(u => ({ value: u.id, text: u.nome })).sort((a, b) => a.text.localeCompare(b.text, 'pt-BR'))
        this.$set(this.usuariosSmtp[index], 'usuariosDisponiveis', disponiveis)
      }
    },

    async salvarUsuarioSmtp(smtpUsr, index) {
      this.$set(this.usuariosSmtp[index], '_salvando', true)
      const refUpload = this.$refs[`uploadUsuario${index}`]
      const file = refUpload ? refUpload[0]?.getFile?.() : null
      const body = {
        id: smtpUsr.id || 0,
        usuarioId: smtpUsr.usuarioId,
        servidor: smtpUsr.servidor,
        porta: Number(smtpUsr.porta),
        criptografia: smtpUsr.criptografia,
        emailRemetente: smtpUsr.emailRemetente,
        login: smtpUsr.login || null,
        senha: smtpUsr.senha,
        descRemetente: smtpUsr.descRemetente || null,
      }
      api.salvarUsuarioSmtp(file, body)
        .then(payload => {
          this.$set(this.usuariosSmtp, index, {
            ...this.usuariosSmtp[index],
            ...payload.data,
            aberto: false,
            _salvando: false,
          })
          this.$sucesso('SMTP do usuário salvo com sucesso')
        })
        .catch(err => {
          this.$set(this.usuariosSmtp[index], '_salvando', false)
          this.$erro(err?.response?.data?.message || 'Erro ao salvar SMTP do usuário')
        })
    },

    removerUsuarioSmtp(index) {
      const smtpUsr = this.usuariosSmtp[index]
      if (!smtpUsr.id) { this.usuariosSmtp.splice(index, 1); return }
      this.$bvModal.msgBoxConfirm('Deseja remover o SMTP deste usuário?', {
        title: 'Confirmar remoção',
        okVariant: 'danger',
        okTitle: 'Remover',
        cancelTitle: 'Cancelar',
      })
        .then(ok => {
          if (!ok) return
          api.removerUsuarioSmtp(smtpUsr.id)
            .then(() => { this.usuariosSmtp.splice(index, 1) })
            .catch(() => this.$erro('Erro ao remover SMTP do usuário'))
        })
    },

    // ── Validações gerais ───────────────────────────────────────────────
    getCriptografiaOptions(porta) {
      const p = Number(porta)
      return [
        { text: 'Nenhum', value: 'none', disabled: false },
        { text: 'SSL', value: 'ssl', disabled: p === 587 },
        { text: 'TSL', value: 'tsl', disabled: p === 465 },
      ]
    },

    ValidarCriptografia() {
      if (this.form.porta === '587' || this.form.porta === 587) {
        this.criptografiaOptions.find(opt => opt.value === 'ssl').disabled = true
        if (this.form.criptografia === 'ssl') this.form.criptografia = this.criptografiaOptions[0].value
      } else {
        this.criptografiaOptions.find(opt => opt.value === 'ssl').disabled = false
      }
      if (this.form.porta === '465' || this.form.porta === 465) {
        this.criptografiaOptions.find(opt => opt.value === 'tsl').disabled = true
        if (this.form.criptografia === 'tsl') this.form.criptografia = this.criptografiaOptions[0].value
      } else {
        this.criptografiaOptions.find(opt => opt.value === 'tsl').disabled = false
      }
    },

    LimparMensagemEmailSaidaErro() { this.emailSaidaMensagemErro = '' },
    LimparMensagemCriptografiaErro() { this.criptografiaMensagemErro = '' },
  },
}
</script>

<style scoped>
/* Seção principal (estilo SenhasAcesso) */
.smtp-secao {
  background-color: rgb(242, 242, 242);
  border-radius: 5px;
  padding: 5px;
}
.smtp-secao-header {
  cursor: pointer;
  padding: 4px 4px;
  user-select: none;
}

/* Cards internos de cada item */
.smtp-adicional-card {
  border: 1px solid #d8d8d8;
  border-radius: 5px;
  overflow: hidden;
  background: #fff;
}
.smtp-adicional-header {
  background: #f2f2f2;
  padding: 8px 12px;
  cursor: pointer;
  user-select: none;
}
.smtp-adicional-body {
  padding: 14px;
}

/* Tags de usuários */
.usuario-tag-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  min-height: 38px;
  height: auto;
}
.usuario-tag {
  background-color: #6d8cc3ed;
  color: #fff;
  border-radius: 4px;
  padding: 2px 6px;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  gap: 4px;
}
.usuario-tag-x {
  cursor: pointer;
  font-weight: bold;
}
.usuario-tag-select {
  border: none;
  outline: none;
  flex: 1;
  min-width: 150px;
  padding: 0;
}
</style>
